module.exports = __webpack_public_path__ + "img/jxsc_icon.3aa5d2ba.svg";